import { useState, useEffect } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ArgumentsSection from "@/components/ArgumentsSection";
import EventsSection from "@/components/EventsSection";
import ContactSection from "@/components/ContactSection";
import PartnersSection from "@/components/PartnersSection";
import NewsletterSection from "@/components/NewsletterSection";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";

export default function LandingPage() {
  const [cookieAccepted, setCookieAccepted] = useState(
    localStorage.getItem("cookie_accepted") === "true"
  );

  const handleAcceptCookies = () => {
    localStorage.setItem("cookie_accepted", "true");
    setCookieAccepted(true);
  };

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#0C1620]">
      <Header />
      <main>
        <HeroSection />
        <ArgumentsSection />
        <EventsSection />
        <ContactSection />
        <NewsletterSection />
        <PartnersSection />
      </main>
      <Footer />
      {!cookieAccepted && <CookieBanner onAccept={handleAcceptCookies} />}
    </div>
  );
}
